import { FormEvent } from "react";
import { Event } from "../../libs/data/event";
import { RegistrationSteps } from "../../libs/registration/registration-steps";
import { AppForm } from "../form/styles/app-form";
import { CtaButton } from "../form/styles/cta-button";
import { EventDescription } from "./registration-info.comp.styles";

export const dayMap: any = {
  0: "Sunday",
  1: "Monday",
  2: "Tusday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
};

export const RegistrationInfoComp = (props: {
  event: Event;
  setStep: (step: RegistrationSteps) => void;
}) => {
  const { event } = props;
  const onClick = async (event: FormEvent) => {
    event.preventDefault();

    props.setStep(RegistrationSteps.Email);
  };

  return (
    <div>
      <EventDescription>
        {event.paymentInfo ? event.paymentInfo : ""}
        {event.description}
      </EventDescription>

      {!!event.day && (
        <p>
          {dayMap[event.day]}: {event.startTime} - {event.endTime}
        </p>
      )}
      <CtaButton onClick={onClick}>Register</CtaButton>
    </div>
  );
};
